import { render, staticRenderFns } from "./CardContact.vue?vue&type=template&id=3c27196c&"
import script from "./CardContact.vue?vue&type=script&lang=js&"
export * from "./CardContact.vue?vue&type=script&lang=js&"
import style0 from "./CardContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports